import { render, staticRenderFns } from "./DiagnosticsCurrent.vue?vue&type=template&id=58fce652&"
import script from "./DiagnosticsCurrent.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports